import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postRegister, CMS_BASE_URL } from '../../redux/action';

import './home.css'; 
import '../common/common.css'; 

import regBanner from '../../images/regBanner.png';

class Register extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "Registration",
	    	name: "",
	    	reg_number: "",
	    	email: "",
	    	password: "",
	    	professional: "",
	    	cpw: "",
	    	s_code: "",
	    	checked: false,
	    	errorName: false,
	    	errorNumber: false,
	    	errorEmail: false,
	    	errorProf: false,
	    	errorPw: false,
	    	errorCpw: false,
	    	errorCode: false,
	    	errorCheck: false,
	    	errorGeneral: false,
	    	underReview: false
	    };
    }

	componentWillMount() {

	}

	validateReg() {
		if (this.state.name == "") {
			this.setState({ errorName: true })
			return
		} else {
			this.setState({ errorName: false })
		}

		if (this.state.reg_number == "") {
			this.setState({ errorNumber: true })
			return
		} else {
			this.setState({ errorNumber: false })
		}

		let emailVal = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (this.state.email == "" || !emailVal.test(this.state.email)) {
			this.setState({ errorEmail: true })
			return
		} else {
			this.setState({ errorEmail: false })
		}

		if (this.state.password == "" || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(this.state.password)) {
			this.setState({ errorPw: true })
			return
		} else {
			this.setState({ errorPw: false })
		}

		if (this.state.password != this.state.cpw) {
			this.setState({ errorCpw: true })
			return
		} else {
			this.setState({ errorCpw: false })
		}

		if (!this.state.professional) {
			this.setState({ errorProf: true })
			return
		} else {
			this.setState({ errorProf: false })
		}

		if (!this.state.checked) {
			this.setState({ errorCheck: true })
			return
		} else {
			this.setState({ errorCheck: false })
		}

		this.postReg();
	}

	postReg() {
		postRegister({ "username": this.state.name,"reg_number": this.state.reg_number,"email": this.state.email,"password": this.state.password, "professional": this.state.professional }).then(res => {
					if (res.data.code == 200) {
						// window.localStorage.setItem("token",res.data.userToken);
						// window.location.href = "/";
						this.setState({ underReview: true });
					}

					if (res.data.code == 402) {
						this.setState({ errorGeneral: true });
					}
		}, this)
	}



	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={regBanner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>{ this.state.title }</h2>
						</div>
						<div className="bodyContent containerMaxWidth memberContainer registerContainer">
							<div className="searchResultSeparator">
								<p className="subHeader">Personal information</p>
							</div>
							
							<div className="inputBox">
								<span>Name: </span>
								<input className="fieldInput" type="text" onChange={(e) => this.setState({ name: e.target.value }) } />
								<p className={this.state.errorName ? "errorRemark active" : "errorRemark"}>Please fill in your name</p>
							</div>
							<div className="inputBox">
								<span>Professional Registration Number: </span>
								<input className="fieldInput" type="text" onChange={(e) => this.setState({ reg_number: e.target.value }) } />
								<p className={this.state.errorNumber ? "errorRemark active" : "errorRemark"}>Please fill in your Professional Registration Number</p>
							</div>
							<div className="inputBox">
								<span>Email Address: </span>
								<input className="fieldInput" type="email" onChange={(e) => this.setState({ email: e.target.value }) } />
								<p className={this.state.errorEmail ? "errorRemark active" : "errorRemark"}>Please fill in a valid email address</p>
							</div>
							<div className="inputBox">
								<span>Professional: </span>
								<div className="fieldInput noBorder">
									<input name="inputProf" type="radio" onChange={(e) => this.setState({ professional: "Physician" }) }  /><span>Physician</span>
									<input name="inputProf" type="radio" onChange={(e) => this.setState({ professional: "Surgeon" }) } /><span>Surgeon</span>
									<input name="inputProf" type="radio" onChange={(e) => this.setState({ professional: "Pharmacist" }) } /><span>Pharmacist</span>
									<input name="inputProf" type="radio" onChange={(e) => this.setState({ professional: "Nurse" }) } /><span>Nurse</span>
								</div>
								<p className={this.state.errorEmail ? "errorRemark active" : "errorRemark"}>Please select one professional</p>
							</div>
							<div className="inputBox">
								<span>Password: </span>
								<input className="fieldInput" type="password" onChange={(e) => this.setState({ password: e.target.value }) } />
								<p className={this.state.errorPw ? "errorRemark active" : "errorRemark"}>Password must contains at least 8 characters with uppercase and lowercase letter, number and symbol</p>
							</div>
							<div className="inputBox">
								<span>Confirmed Password: </span>
								<input className="fieldInput" type="password" onChange={(e) => this.setState({ cpw: e.target.value }) } />
								<p className={this.state.errorCpw ? "errorRemark active" : "errorRemark"}>Password does not match </p>
							</div>
							<div className="inputBox" style={{ "display": "none" }}>
								<span>Security Code: </span>
								<input className="fieldInput" type="text" />
								<p className="errorRemark"></p>
							</div> 
							<div className="tncInput inputBox">
								<input type="checkbox" onChange={() => this.setState({ checked: !this.state.checked })} />
								<span>I confirm that I have read and agree to the <a href="https://www.azprivacy.astrazeneca.com/asia-pacific/hongkong/en/privacy-notices.html#accordion-list-item-75b4bb02e1" target="_blank" rel="noopener">Astrazeneca's privacy policy</a> and <a target="_blank" href="https://www.daiichisankyo.com.hk/Privacy/">Daiichisankyo's privacy policy</a></span>
								<p className={this.state.errorCheck ? "errorRemark active" : "errorRemark"}>Please confirm your read the Terms and Conditions</p>
							</div>

							{
								(!this.state.underReview) ? (
									<div>
										<div className="buttonBox" onClick={() => this.validateReg()}>
											<div className="memberBtn actionBtn">
												<a><span>CONFIRM</span></a>
											</div>
											<div className="memberBtn resetBtn actionBtn">
												<a href="/"><span>CANCEL</span></a>
											</div>
										</div>
										<p style={{ textAlign: 'center', position: 'relative' }} className={this.state.errorGeneral ? "errorRemark active" : "errorRemark"}>Email address is already registered</p>
									</div>
								) : (
									<div className="underReviewPopup">
										<p>Your account is under review. We will notify you by email once the review is complete.</p>
										<div className="buttonBox" onClick={() => window.location.href = "/" }>
											<div className="confirmBtn memberBtn actionBtn">
													<a><span>CONFIRM</span></a>
											</div>
										</div>
									</div>
								)
							}

						</div>
						
					</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Register));